module.exports = __webpack_public_path__ + "img/CA.e509dccf.png";